export default (function ($q, EndorsementService, RenewalService) {

    var ACTIONS = {
        load: function load(model) {
            return $q.resolve(model);
        },
        cancel: function cancel(model, args) {
            if (model.value.baseData.jobType === 'PolicyChange') {
                var notQuoted = model.status.value.code !== 'Quoted';
                if (notQuoted) {
                    return EndorsementService.saveEndorsement(model.value);
                }
            } else if (model.value.baseData.jobType === 'Renewal') {
                var isQuoted = model.value.baseData.periodStatus === 'Quoted';
                if (isQuoted && args.modelEdited) {
                    return RenewalService.updatePaymentPlan(args.modelEdited).then(function () {
                        return model;
                    }); // args is receiving the model with the current edited state
                } else if (!isQuoted) {
                    return RenewalService.saveRenewal(model.value);
                }
            }
            return $q.resolve(model.value);
        }
    };

    var ACTION_MSG = {
        load: {
            error: {
                title: 'gw-portals-policytransaction-common-angular.config.flowConfig.Unable to load',
                message: 'gw-portals-policytransaction-common-angular.config.flowConfig.An error occurred while attempting to load.'
            }
        },
        cancelPrompt: {
            message: 'gw-portals-policytransaction-common-angular.config.flowConfig.The information previously entered will be stored'
        },
        save: {
            error: {
                title: 'gw-portals-policytransaction-common-angular.config.flowConfig.Unable to save',
                message: 'gw-portals-policytransaction-common-angular.config.flowConfig.An error occurred while attempting to save.'
            },
            progress: {
                message: 'gw-portals-policytransaction-common-angular.config.flowConfig.Saving...'
            }
        }
    };

    return function (step, junction) {
        junction('entry', true).onNext.doAction(ACTIONS.load, ACTION_MSG.load).thenGoTo('Fin');

        junction('transactionError');

        junction('returnHome');

        junction('cancel').data({
            confirmationMsg: function confirmationMsg() {
                return ACTION_MSG.cancelPrompt.message;
            }
        }).onNext.doAction(ACTIONS.cancel, ACTION_MSG.save).thenGoTo('returnHome', 'transactionError');

        junction('confirmation');
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-policytransaction-common-angular/config/FlowConfig.js
// module id = 342
// module chunks = 0